export default function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
}



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/d3-array/src/threshold/sturges.js
// module id = ../../../../d3-array/src/threshold/sturges.js
// module chunks = 4